import Vue from 'vue'
import App from '@/App.vue'
import router from '@/router'
import store from '@/store'
import vuetify from '@/plugins/vuetify';
import '@/plugins/axios';
import '@/plugins/base';
import i18n from '@/plugins/i18n';
import '@/plugins/echo'; // not needed for now
import '@/plugins/vuetify-toast';
import '@/plugins/vuetify-datetime-picker';
import '@/plugins/vue-moment';

Vue.config.productionTip = false

export const app = new Vue({
	router,
	store,
	vuetify,
	i18n,
	render: h => h(App)
}).$mount('#app')
